import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";

export default function B2BToB2COrderModal({
  b2BToB2COrderModal,
  setB2BToB2COrderModal,
  sendDataToOrderInfoPage,
}) {
  const navigate = useNavigate();

  const handleConfirmDeleteOrder = () => {
  
    sendDataToOrderInfoPage({
      info: true,
    });

    setB2BToB2COrderModal(false);

  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setB2BToB2COrderModal(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={b2BToB2COrderModal}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!b2BToB2COrderModal) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-cart-minus"
                style={{ fontSize: "40px", color: "#fff" }}
              ></i>
              <p className=" text-2xl text-primary-50 font-semibold uppercase">
                Confirm B2B To B2C Order
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div>
              <p className=" w-full text-xl  font-semibold flex justify-content-center">Please Confirm Do You Want To Convert This Challan To Order</p>
            </div>

            <div className="flex">
            <Button
              onClick={handleConfirmDeleteOrder}
              className="mt-1 mb-3 mx-4 border-round-xl flex-1"
            >
              <p className=" w-full text-xl  font-semibold flex justify-content-center">
                YES
              </p>
            </Button>
            <Button
              onClick={() => setB2BToB2COrderModal(false)}
              className="mt-1 mb-3 mx-4 border-round-xl flex-1"
            >
              <p className=" w-full text-xl  font-semibold flex justify-content-center">
                No
              </p>
            </Button>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
